<template>
  <div class="wrapper">
    <div class="ccui-app-container">
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
          <template slot="bigClassName" slot-scope="{ row }">
            <span>{{ row.bigClassName.join(",") }}</span>
          </template>
          <template slot="purchaseTypeName" slot-scope="{ row }">
            <!-- row.purchaseType == "2"
                ? row.purchaseClassName
                  ? row.purchaseClassName
                  : row.purchaseTypeName
                : row.purchaseTypeName -->
            <span>{{
              row.purchaseType == "2"
                ? row.purchaseClassName
                  ? row.purchaseClass == "108"
                    ? $t("page.content.openSingleSource")
                    : row.purchaseClass == "105"
                    ? $t("page.content.openOfflineBidding")
                    : row.purchaseClass == "109"
                    ? $t("page.content.offlinePublicInquiry")
                    : row.purchaseClass == "107"
                    ? $t("page.content.openCollaboration")
                    : row.purchaseType == 8 && row.purchaseCategory == "4"
                    ? $t("page.content.publicAuction")
                    : ""
                  : row.purchaseType == "1"
                  ? $t("page.content.inquiry")
                  : row.purchaseType == "2"
                  ? $t("page.content.otherProcurement")
                  : row.purchaseType == "5"
                  ? $t("page.content.inviteBidd")
                  : row.purchaseType == "7"
                  ? $t("page.content.labelMenu10")
                  : row.purchaseType == "8"
                  ? $t("page.content.labelMenu11")
                  : row.purchaseType == "24"
                  ? $t("page.content.openCompetitiveNegotiation")
                  : row.purchaseType == "4"
                  ? $t("page.content.competitiveNegotiation")
                  : row.purchaseType == "50"
                  ? $t("page.content.agreementType")
                  : row.purchaseType == "53"
                  ? $t("page.content.invitationType")
                  : row.purchaseType == "0"
                  ? $t("page.content.publicBidding")
                  : row.purchaseType == "3"
                  ? $t("page.content.invitationTender")
                  : ""
                : row.purchaseType == "1"
                ? $t("page.content.inquiry")
                : row.purchaseType == "2"
                ? $t("page.content.otherProcurement")
                : row.purchaseType == "5"
                ? $t("page.content.inviteBidd")
                : row.purchaseType == "7"
                ? $t("page.content.labelMenu10")
                : row.purchaseType == "8"
                ? $t("page.content.labelMenu11")
                : row.purchaseType == "24"
                ? $t("page.content.openCompetitiveNegotiation")
                : row.purchaseType == "4"
                ? $t("page.content.competitiveNegotiation")
                : row.purchaseType == "50"
                ? $t("page.content.agreementType")
                : row.purchaseType == "53"
                ? $t("page.content.invitationType")
                : row.purchaseType == "0"
                ? $t("page.content.publicBidding")
                : row.purchaseType == "3"
                ? $t("page.content.invitationTender")
                : ""
            }}</span>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth, limitPurchaseType } from "@/setting/setting";
import { listSupBidNotice, listDictByCode } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "noticeViewAllList",
  mixins: [mixinListCommon],
  props: {
    noticeType: {
      type: Number,
      default: 7 //公告类型
    },
    noticeTime: {
      type: Array,
      default: () => []
    },
    noticeTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      purchaseTypeOptions: [
        {
          //公开招标
          dicKey: "0",
          dicValue: this.$t("page.content.publicBidding")
        },
        {
          //询价采购
          dicKey: "1",
          dicValue: this.$t("page.content.inquiry")
        },
        {
          //其他采购
          dicKey: "2",
          dicValue: this.$t("page.content.otherProcurement")
        },
        {
          //邀请招标
          dicKey: "3",
          dicValue: this.$t("page.content.invitationTender")
        },
        {
          //竞争谈判
          dicKey: "4",
          dicValue: this.$t("page.content.labelMenu8")
        },
        {
          //邀请竞价
          dicKey: "5",
          dicValue: this.$t("page.content.inviteBidd")
        },
        {
          //(协议类)公开招标
          dicKey: "50",
          dicValue: this.$t("page.content.agreementTypeOpenBidding")
        },
        {
          //(协议类)邀请招标
          dicKey: "53",
          dicValue: this.$t("page.content.invitationToTenderagreement")
        },
        {
          //公开询价
          dicKey: "7",
          dicValue: this.$t("page.content.labelMenu10")
        },
        {
          //公开竞价
          dicKey: "8",
          dicValue: this.$t("page.content.labelMenu11")
        },
        {
          //公开性竞争谈判
          dicKey: "24",
          dicValue: this.$t("page.content.openCompetitiveNegotiations")
        }
      ],
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: this.$t("page.content.serialNo"),
          prop: "id",
          type: "index",
          width: this.$TW.serialNoWidth,
          checked: true
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          width: 500,
          checked: true,
          slot: "title"
        },
        // {
        //   //类别
        //   label: this.$t("page.content.category"),
        //   prop: "bigClassName",
        //   // width: 500,
        //   checked: true,
        //   slot: "bigClassName"
        // },
        {
          //采购方式
          label: this.$t("page.content.purchaseType"),
          prop: "purchaseTypeName",
          // width: 500,
          width: 300,
          checked: true,
          slot: "purchaseTypeName"
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "noticeStartTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      supInfo: this.$store.state.user.supInfo || {}
    };
  },
  mounted() {
    this.initData();
    this.getNoticeList();
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    getPurchaseType() {
      listDictByCode({
        code: "SCHEME_PURCHASE_TYPE",
        purSupFlag: "sup"
      }).then(res => {
        if (limitPurchaseType.unseal) {
          this.purchaseTypeOptions = res.data.data.filter(item => {
            return limitPurchaseType.allowArr.includes(item.dicKey);
          });
        } else {
          this.purchaseTypeOptions = res.data.data;
        }
      });
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeType: this.noticeType,
        noticeStatusEndFlag: "1", //是否查询已结束的公告 0-否 1-是
        isShowPageLoading: true,
        supCodeList: supCodeList,
        noticeTitle: this.noticeTitle,
        title: this.noticeTitle
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        param.overseasSupFlag = 1;
      }
      if (this.noticeTime && this.noticeTime.length !== 0) {
        this.formDataSearch.noticeTimeStart = this.noticeTime[0] + " 00:00:00";
        this.formDataSearch.noticeTimeEnd = this.noticeTime[1] + " 23:59:59";
      } else {
        this.formDataSearch.noticeTimeStart = null;
        this.formDataSearch.noticeTimeEnd = null;
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "noticeTime");
      listSupBidNotice(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.noticeStartTime = item.noticeStartTime
              ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      const { isJRZL, searchType } = this.$route.query;
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          isJRZL,
          searchType,
          type: this.type,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType
        }
      });
      window.open(url.href, "_blank");
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  },
  watch: {
    noticeType: {
      handler(val) {
        this.initData();
        this.getNoticeList();
      }
    },
    noticeTime: {
      handler(val) {
        this.initData();
        this.getNoticeList();
      }
    },
    noticeTitle: {
      handler(val) {
        this.initData();
        this.getNoticeList();
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
